<template>
    <div>
        <div class="VueTables__primary-content">{{ data.client_name }}</div>
        <div class="VueTables__secondary-content">{{ data.client_prefixed_name }}</div>
    </div>
</template>

<script>
    export default {
        props: ['data', 'index', 'column'],
    }
</script>
